<button type="button" class="btn btn-dark btn-lg btn-block rounded-0 border-0 text-left d-flex flex-row pr-0 mr-0 pl-1 pb-0 pt-0" (click)='openLink()'>
  <div class="usefullink-item-container d-flex flex-column text-truncate">
    <span class="p-0 mb-0 font-weight-light" [ngClass]="{'font-weight-bold': usefulLink.priority}">{{usefulLink.displayName}}</span>
  </div>
</button>

